export enum Route {
  BASE = '/',
  CALLBACK = 'callback',
  DATA_AND_AI_LEARNINGS = 'data-and-ai-learnings',
  FAQS = 'faqs',
  GAME = 'game',
  IMPRINT = 'imprint',
  LOGIN = 'login',
  WINNER = 'winner',
}
